export var CallVolumeBreakdownType;
(function (CallVolumeBreakdownType) {
    CallVolumeBreakdownType[CallVolumeBreakdownType["ALL"] = 0] = "ALL";
    CallVolumeBreakdownType[CallVolumeBreakdownType["LOCALE"] = 1] = "LOCALE";
    CallVolumeBreakdownType[CallVolumeBreakdownType["LOCATION"] = 2] = "LOCATION";
    CallVolumeBreakdownType[CallVolumeBreakdownType["COUNTRY"] = 3] = "COUNTRY";
    CallVolumeBreakdownType[CallVolumeBreakdownType["CALL_STATUS"] = 4] = "CALL_STATUS";
    CallVolumeBreakdownType[CallVolumeBreakdownType["QUEUE"] = 5] = "QUEUE";
    CallVolumeBreakdownType[CallVolumeBreakdownType["LINE"] = 6] = "LINE";
    CallVolumeBreakdownType[CallVolumeBreakdownType["CALL_TYPE"] = 7] = "CALL_TYPE";
    CallVolumeBreakdownType[CallVolumeBreakdownType["LOCATION_ID"] = 8] = "LOCATION_ID";
})(CallVolumeBreakdownType || (CallVolumeBreakdownType = {}));
export var OverviewMetrics;
(function (OverviewMetrics) {
    OverviewMetrics[OverviewMetrics["COMPLETED_CALLS"] = 1] = "COMPLETED_CALLS";
    OverviewMetrics[OverviewMetrics["WAIT_TIME"] = 2] = "WAIT_TIME";
    OverviewMetrics[OverviewMetrics["HANDLE_TIME"] = 3] = "HANDLE_TIME";
    OverviewMetrics[OverviewMetrics["WRAP_UP_TIME"] = 4] = "WRAP_UP_TIME";
    OverviewMetrics[OverviewMetrics["ABANDON_RATE"] = 5] = "ABANDON_RATE";
    OverviewMetrics[OverviewMetrics["SATISFACTION_SCORE"] = 7] = "SATISFACTION_SCORE";
})(OverviewMetrics || (OverviewMetrics = {}));
export var OverviewMetricsBreakdown;
(function (OverviewMetricsBreakdown) {
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["LOCATION"] = 1] = "LOCATION";
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["QUEUE"] = 2] = "QUEUE";
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["LINE"] = 3] = "LINE";
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["LOCALE"] = 4] = "LOCALE";
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["COUNTRY"] = 5] = "COUNTRY";
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["CALL_STATUS"] = 6] = "CALL_STATUS";
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["CALL_TYPE"] = 7] = "CALL_TYPE";
    OverviewMetricsBreakdown[OverviewMetricsBreakdown["LOCATION_ID"] = 8] = "LOCATION_ID";
})(OverviewMetricsBreakdown || (OverviewMetricsBreakdown = {}));
export var OverviewTableMetrics;
(function (OverviewTableMetrics) {
    OverviewTableMetrics[OverviewTableMetrics["TOTAL_CALLS"] = 1] = "TOTAL_CALLS";
    OverviewTableMetrics[OverviewTableMetrics["COMPLETED_CALLS"] = 2] = "COMPLETED_CALLS";
    OverviewTableMetrics[OverviewTableMetrics["WAIT_TIME"] = 3] = "WAIT_TIME";
    OverviewTableMetrics[OverviewTableMetrics["HANDLE_TIME"] = 4] = "HANDLE_TIME";
    OverviewTableMetrics[OverviewTableMetrics["WRAP_UP_TIME"] = 5] = "WRAP_UP_TIME";
    OverviewTableMetrics[OverviewTableMetrics["ABANDON_RATE"] = 6] = "ABANDON_RATE";
    OverviewTableMetrics[OverviewTableMetrics["SATISFACTION_SCORE"] = 7] = "SATISFACTION_SCORE";
})(OverviewTableMetrics || (OverviewTableMetrics = {}));
export var OverviewTableMetricsSorting;
(function (OverviewTableMetricsSorting) {
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["BREAKDOWN_KEY_ASC"] = 1] = "BREAKDOWN_KEY_ASC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["BREAKDOWN_KEY_DESC"] = 2] = "BREAKDOWN_KEY_DESC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["TOTAL_CALLS_ASC"] = 3] = "TOTAL_CALLS_ASC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["TOTAL_CALLS_DESC"] = 4] = "TOTAL_CALLS_DESC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["COMPLETED_CALLS_ASC"] = 5] = "COMPLETED_CALLS_ASC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["COMPLETED_CALLS_DESC"] = 6] = "COMPLETED_CALLS_DESC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["WAIT_TIME_ASC"] = 7] = "WAIT_TIME_ASC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["WAIT_TIME_DESC"] = 8] = "WAIT_TIME_DESC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["HANDLE_TIME_ASC"] = 9] = "HANDLE_TIME_ASC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["HANDLE_TIME_DESC"] = 10] = "HANDLE_TIME_DESC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["WRAP_UP_TIME_ASC"] = 11] = "WRAP_UP_TIME_ASC";
    OverviewTableMetricsSorting[OverviewTableMetricsSorting["WRAP_UP_TIME_DESC"] = 12] = "WRAP_UP_TIME_DESC";
})(OverviewTableMetricsSorting || (OverviewTableMetricsSorting = {}));
//# sourceMappingURL=domain.js.map